/**
 * External dependencies
 */
import React, { useState } from "react";
import { Box, Heading } from "@towersystems/towersystems-design-system";
import classnames from "classnames";
import { connect } from "react-redux";
import { map } from "lodash";

/**
 * Internal dependencies
 */
import {
  Layout,
  Topbar,
  Content,
  Sidebar,
} from "modules/report-builder/layout";
import DataTypeList from "./data-type-list";
import { dataTypes, dataTypeComponentMap } from "./constants";
import Button from "components/button";
import { editReport } from "state/reports/actions";
import { getBuilderReportId } from "state/ui/report-builder/selectors";
import { getPreviousPath } from "state/ui/selectors";

/**
 * Style dependencies
 */
import "./styles.scss";

const SelectReportOn = ({ reportId, previousPath, goToNextStep, ...props }) => {
  // this could be managed in redux, though at present.. there is no reason to.
  const [dataType, setDataType] = useState("single");
  const [dataSet, setDataSet] = useState("");

  const handleDataTypeChanged = (value) => {
    setDataType(value);
    if (value !== dataType) {
      setDataSet(""); // clear the data set if data type changes
    }
  };

  const handleGoNext = () => {
    if (dataSet && dataType) {
      props.editReport(reportId, {
        config: {
          dataType,
          dataSet,
        },
      });
      goToNextStep();
    }
  };

  // data props
  //
  const classes = classnames("report-builder__select-report-on-wrapper");

  const sidebarContent = (
    <Box className={classes}>
      <Box marginBottom="large">
        <Heading level="3">What do you want to report on?</Heading>
      </Box>
      <DataTypeList
        items={map(dataTypes, (type) => ({ key: type.value, ...type }))}
        value={dataType}
        onChange={handleDataTypeChanged}
      />
    </Box>
  );

  const DataSetComponent = dataTypeComponentMap[dataType];

  // only allow continue if all data has been selected
  const canGoNext = dataSet && dataType;

  return (
    <Layout>
      {({ classes, innerWrapperClasses }) => {
        return (
          <Box className={classes}>
            <Topbar>
              <>
                <Button link={previousPath} lined>
                  Exit
                </Button>
                <Button onClick={handleGoNext} secondary disabled={!canGoNext}>
                  Next
                </Button>
              </>
            </Topbar>
            <Box className={innerWrapperClasses}>
              <Sidebar position="left">{sidebarContent}</Sidebar>
              <Content>
                {DataSetComponent && (
                  <DataSetComponent value={dataSet} onChange={setDataSet} />
                )}
              </Content>
            </Box>
          </Box>
        );
      }}
    </Layout>
  );
};

export default connect(
  (state) => ({
    reportId: getBuilderReportId(state),
    previousPath: getPreviousPath(state),
  }),
  {
    editReport,
  }
)(SelectReportOn);
